import { useCallback, useState } from 'react';
import { usePaginationParams } from '@common-fe/common-fe';

const DEFAULT_PAGE_SIZE = 10;

const useEmployeeLoginHistoryParams = () => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const { page, perPage, setPerPage, setPage } = usePaginationParams(DEFAULT_PAGE_SIZE);

  const handleSetPeriod = useCallback((dates: [Date | null, Date | null]) => {
    if (dates[0] === null) {
      setStartDate(null);
      setEndDate(null);
    } else {
      setStartDate(dates[0]);
      setEndDate(dates[1]);
    }
  }, []);

  return {
    page,
    perPage,
    setPerPage,
    setPage,
    startDate,
    endDate,
    setPeriod: handleSetPeriod,
  };
};

export default useEmployeeLoginHistoryParams;
